"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.richTextEditorPropTypes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _hooks = require("../hooks");

var _propTypes = require("../prop-types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var JSONContentPropTypes = {
  type: _stencilReactDesc.PropTypes.string,
  attrs: _stencilReactDesc.PropTypes.object,
  marks: _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.object),
  text: _stencilReactDesc.PropTypes.string
};

var contentPropType = _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.shape(_objectSpread(_objectSpread({}, JSONContentPropTypes), {}, {
  content: _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.shape(JSONContentPropTypes))
}))]);

var colorLocalizationSharedShape = {
  colorGreenTitleText: _stencilReactDesc.PropTypes.string,
  colorPinkTitleText: _stencilReactDesc.PropTypes.string,
  colorPurpleTitleText: _stencilReactDesc.PropTypes.string,
  colorRedTitleText: _stencilReactDesc.PropTypes.string,
  colorYellowTitleText: _stencilReactDesc.PropTypes.string,
  colorWhiteTitleText: _stencilReactDesc.PropTypes.string,
  arialRoleHighlightText: _stencilReactDesc.PropTypes.string,
  arialRoleFontText: _stencilReactDesc.PropTypes.string,
  selectedText: _stencilReactDesc.PropTypes.string
};
var richTextEditorPropTypes = {
  'aria-label': _stencilReactDesc.PropTypes.string.description("Sets the 'aria-label' attribute for the editor."),
  'aria-labelledby': _stencilReactDesc.PropTypes.string.description("Sets the 'aria-labelledby' attribute for the editor."),
  id: _stencilReactDesc.PropTypes.string.description("Sets the 'id' attribute for the editor."),
  content: contentPropType.description('This property you can provide content for the editor. This can be HTML or JSON.'),
  defaultContent: contentPropType.description('This property you can provide the initial content for the editor. This can be HTML or JSON.'),
  placeholder: _stencilReactDesc.PropTypes.string.description('Text to display in the editor when content is empty.'),
  controls: _stencilReactDesc.PropTypes.object.description('Set partial configuration of the editor controls.'),
  extensions: _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.object).description('Extensions to improve/customize the editor. More: https://tiptap.dev/api/extensions#create-a-new-extension.'),
  disabled: _stencilReactDesc.PropTypes.bool.description('Prevents the user from interacting with the component.'),
  shouldDisableMarkdownShortcuts: _stencilReactDesc.PropTypes.bool.description('Disable Markdown shortcuts when typing and pasting.'),
  showToolbar: _stencilReactDesc.PropTypes.bool.description("This property to show or hide the editor's toolbar."),
  isFullScreen: _stencilReactDesc.PropTypes.bool.description('Default fullscreen state of the editor.'),
  defaultHeight: (0, _propTypes.cssValue)().description('Default height of the editor content.'),
  maxHeight: (0, _propTypes.cssValue)().description("Sets the CSS 'max-height' property for the editor content."),
  onBlur: _stencilReactDesc.PropTypes.func.description('Callback called on content blur event.'),
  onChange: _stencilReactDesc.PropTypes.func.description('Callback function that will be called when the editor content is changed. It passes the editor instance.').format('(editor: EditorInstance) => void'),
  onCreate: _stencilReactDesc.PropTypes.func.description('Callback function that will be called when the editor gets created. It passes the editor instance.').format('(editor: EditorInstance) => void'),
  onFocus: _stencilReactDesc.PropTypes.func.description('Callback called on content focus event.'),
  readOnly: _stencilReactDesc.PropTypes.bool.description('Prevents the user from editing the editor content.'),
  updateInstance: _stencilReactDesc.PropTypes.func.description('Callback to pass updated editor instance.'),
  hasWordCounter: _stencilReactDesc.PropTypes.bool.description('Toggle the display of a recommended length footer.'),
  recommendedWordCount: _stencilReactDesc.PropTypes.number.description('Recommended maximum number of words the user should enter.'),
  recommendedWordCountTokenType: _stencilReactDesc.PropTypes.oneOf(Object.values(_hooks.TokenType)).description('Sets whether to count `Words` or `Characters` entered.'),
  shouldWordCounterLiveAnnounce: _stencilReactDesc.PropTypes.bool.description('Toggle the recommended length footer announcement.'),
  getErrorText: _stencilReactDesc.PropTypes.func.description('Function to display an error message in the recommended length footer.').format("() => string"),
  getExceededText: _stencilReactDesc.PropTypes.func.description('Function to display a message when the recommended word length is exceeded.').format("({ wordCount: number, recommendedWordCount: number }) => string"),
  getRecommendedText: _stencilReactDesc.PropTypes.func.description('Function used to return the recommended characters message.').format("({ wordCount: number, recommendedWordCount: number }) => string"),
  statusIndicatorProps: _stencilReactDesc.PropTypes.any.description('Status Indicator to for visual representation of status.'),
  keyboardShortcutsLocalization: _stencilReactDesc.PropTypes.shape({
    title: _stencilReactDesc.PropTypes.string,
    closeButtonText: _stencilReactDesc.PropTypes.string,
    groupTitles: _stencilReactDesc.PropTypes.object,
    commandTitles: _stencilReactDesc.PropTypes.object,
    'aria-label': _stencilReactDesc.PropTypes.string
  }).description('Localization for a "Keyboard Shortcuts modal" in the editor.'),
  keyboardShortcutsAltText: _stencilReactDesc.PropTypes.string.description('Set different alt text for "Keyboard Shortcuts modal".'),
  keyboardShortcutsHintText: _stencilReactDesc.PropTypes.string.description('Set different hint text at the bottom for "Keyboard Shortcuts modal".'),
  imageModalLocalization: _stencilReactDesc.PropTypes.shape({
    altError: _stencilReactDesc.PropTypes.string,
    altDecorativeFooterInfo: _stencilReactDesc.PropTypes.string,
    altPrompt: _stencilReactDesc.PropTypes.string,
    //TODO remove this closeButtonAltText prop in 4.0
    closeButtonAltText: _stencilReactDesc.PropTypes.string,
    closeDialogAltText: _stencilReactDesc.PropTypes.string,
    decorativeCheckboxPrompt: _stencilReactDesc.PropTypes.string,
    dimensionsTitleText: _stencilReactDesc.PropTypes.string,
    getImageEditableMessage: _stencilReactDesc.PropTypes.func.format("(imageAltText: string) => string"),
    heightPrompt: _stencilReactDesc.PropTypes.string,
    insertSubmitButtonText: _stencilReactDesc.PropTypes.string,
    insertTitleText: _stencilReactDesc.PropTypes.string,
    retainProportionsCheckboxPrompt: _stencilReactDesc.PropTypes.string,
    srcError: _stencilReactDesc.PropTypes.string,
    srcPrompt: _stencilReactDesc.PropTypes.string,
    toolbarButtonAddAltText: _stencilReactDesc.PropTypes.string,
    toolbarButtonEditAltText: _stencilReactDesc.PropTypes.string,
    updateSubmitButtonText: _stencilReactDesc.PropTypes.string,
    updateTitleText: _stencilReactDesc.PropTypes.string,
    widthPrompt: _stencilReactDesc.PropTypes.string
  }).description('Localization for the "Image modal" in the editor.'),
  linkModalLocalization: _stencilReactDesc.PropTypes.shape({
    clearLinkButtonText: _stencilReactDesc.PropTypes.string,
    //TODO remove this closeButtonAltText prop in 4.0
    closeButtonAltText: _stencilReactDesc.PropTypes.string,
    closeDialogAltText: _stencilReactDesc.PropTypes.string,
    inputLabelText: _stencilReactDesc.PropTypes.string,
    insertLinkButtonText: _stencilReactDesc.PropTypes.string,
    modalTitleText: _stencilReactDesc.PropTypes.string,
    toolbarButtonAddAltText: _stencilReactDesc.PropTypes.string,
    toolbarButtonEditAltText: _stencilReactDesc.PropTypes.string
  }).description('Localization for the "Link modal" in the editor.'),
  tablePopoverLocalization: _stencilReactDesc.PropTypes.shape({
    createTableTitleText: _stencilReactDesc.PropTypes.string,
    addRowTitleText: _stencilReactDesc.PropTypes.string,
    addColumnTitleText: _stencilReactDesc.PropTypes.string,
    removeRowTitleText: _stencilReactDesc.PropTypes.string,
    removeColumnTitleText: _stencilReactDesc.PropTypes.string,
    toolbarButtonAddAltText: _stencilReactDesc.PropTypes.string,
    toolbarButtonEditAltText: _stencilReactDesc.PropTypes.string
  }).description('Localization for the "Table popover" in the editor.'),
  tableModalLocalization: _stencilReactDesc.PropTypes.shape({
    createTableTitleText: _stencilReactDesc.PropTypes.string,
    rowQuantityTitleText: _stencilReactDesc.PropTypes.string,
    columnQuantityText: _stencilReactDesc.PropTypes.string,
    altTitleText: _stencilReactDesc.PropTypes.string,
    accessibilityTitleText: _stencilReactDesc.PropTypes.string,
    modalDescriptionText: _stencilReactDesc.PropTypes.string,
    cancelButtonText: _stencilReactDesc.PropTypes.string,
    //TODO remove this cancelButtonAltText prop in 4.0
    cancelButtonAltText: _stencilReactDesc.PropTypes.string,
    closeDialogAltText: _stencilReactDesc.PropTypes.string,
    confirmButtonText: _stencilReactDesc.PropTypes.string,
    confirmButtonAltText: _stencilReactDesc.PropTypes.string,
    inputErrorText: _stencilReactDesc.PropTypes.string,
    inputErrorAltTitleText: _stencilReactDesc.PropTypes.string,
    rowErrorOnlyNumbersText: _stencilReactDesc.PropTypes.string,
    columnErrorOnlyNumbersText: _stencilReactDesc.PropTypes.string,
    createTableErrorText: _stencilReactDesc.PropTypes.string,
    dismissButtonAltText: _stencilReactDesc.PropTypes.string,
    messageBannerIconAltText: _stencilReactDesc.PropTypes.string,
    getTableEditableMessage: _stencilReactDesc.PropTypes.func.format("(tableAltText: string) => string"),
    getTableHeaderCellMessage: _stencilReactDesc.PropTypes.func.format("() => string"),
    getTableSelectedCellMessage: _stencilReactDesc.PropTypes.func.format("(cells: number) => string"),
    getTableSelectedCellSingularMessage: _stencilReactDesc.PropTypes.func.format("() => string")
  }).description('Localization for a "Modal" in the table.'),
  tableEditModalLocalization: _stencilReactDesc.PropTypes.shape({
    editTableTitleText: _stencilReactDesc.PropTypes.string,
    modalDescriptionText: _stencilReactDesc.PropTypes.string,
    inputTitleText: _stencilReactDesc.PropTypes.string,
    cancelButtonText: _stencilReactDesc.PropTypes.string,
    //TODO remove this cancelButtonAltText prop in 4.0
    cancelButtonAltText: _stencilReactDesc.PropTypes.string,
    closeDialogAltText: _stencilReactDesc.PropTypes.string,
    confirmButtonText: _stencilReactDesc.PropTypes.string,
    confirmButtonAltText: _stencilReactDesc.PropTypes.string,
    inputErrorAltTitleText: _stencilReactDesc.PropTypes.string
  }).description('Localization for a "Edit Modal" in the table.'),
  fontColorPopoverLocalization: _stencilReactDesc.PropTypes.shape(_objectSpread(_objectSpread({}, colorLocalizationSharedShape), {}, {
    fontColorTitleText: _stencilReactDesc.PropTypes.string,
    colorBlackTitleText: _stencilReactDesc.PropTypes.string
  })).description('Localization for a "Font Color popover" in the editor.'),
  highlightPopoverLocalization: _stencilReactDesc.PropTypes.shape(_objectSpread(_objectSpread({}, colorLocalizationSharedShape), {}, {
    highlightTitleText: _stencilReactDesc.PropTypes.string,
    noHighlightText: _stencilReactDesc.PropTypes.string
  })).description('Localization for a "Highlight popover" in the editor.')
};
exports.richTextEditorPropTypes = richTextEditorPropTypes;